<script>
	import { fly } from 'svelte/transition';
	import Filters from '../stores/filters';
	import Preload from '../../utils/preload';
	export let show = false;
	let filters = {};
	fetch("https://crm.lamara.in/products/products/filterslist").then(res => res.json()).then(res => filters = res.data);
</script>
<svelte:head>
	{#if show}
		<style>
			body {
				overflow: hidden;
			}
		</style>
	{/if}
</svelte:head>
{#if show}
	{#await Preload('/images/pattern2.png')}
		<span></span>
	{:then base64}
		<nav class="right-nav" transition:fly={{x: 250, opacity: 1}}>
			<div class="thick-border"></div>
			<div class="thin-border"></div>
			<div class="menu-items">
				<div class="container-fluid">
					<div class="d-flex">
						<div class="box">
							<h4>Filters</h4>
							{#if $Filters.filters_list.length}
								<a href="#" class="clear-filter-btn" on:click|preventDefault={e => $Filters.filters_list = []}>Clear</a>
							{/if}
							<ul class="filters">
								{#each filters.filters_list as filter}
									<li>
										<input type="checkbox" bind:group={$Filters.filters_list} value={filter}/>{filter.filtername}
									</li>
								{/each}
							</ul>
							{#if filters.product_sizes}
								<h4>Sizes</h4>
								{#if $Filters.product_sizes.length}
									<a href="#" class="clear-filter-btn" on:click|preventDefault={e => $Filters.product_sizes = []}>Clear</a>
								{/if}
								<ul class="filters">
									{#each filters.product_sizes as size}
										<li>
											<input type="checkbox" bind:group={$Filters.product_sizes} value={size}/>
											{size.size}
										</li>
									{/each}
								</ul>
							{/if}
							<h4>Sort</h4>
							<ul class="filters">
								<li>
									<input type="radio" bind:group={$Filters.product_sort} value="new"/>
									Newest
								</li>
								<li>
									<input type="radio" bind:group={$Filters.product_sort} value="old"/>
									Oldest
								</li>
								<li>
									<input type="radio" bind:group={$Filters.product_sort} value="high_price"/>
									Price high to low
								</li>
								<li>
									<input type="radio" bind:group={$Filters.product_sort} value="low_price"/>
									Price low to high
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<button class="btn close-btn" on:click={() => show = false}>
				<img src="/images/x_mark.png" alt="Close" class="close-icon">
				<img src="/images/x_mark.png" alt="Close" class="close-icon close-icon-active">
			</button>
		</nav>
		<div class="patch" on:click={() => show = false}></div>
	{/await}
{/if}
<style>
	nav {
		position: relative;
	}

	nav {
		position: fixed;
		z-index: 9999;
		top: 0;
		right: 0;
		height: 100%;
		padding: 2rem 1rem 0.6rem 3em;
		border-left: 1px solid #aaa;
		overflow-y: auto;
		width: 20rem;
		background-image: url("/images/pattern2.png");
		opacity: 1;
	}

	.thick-border {
		position: absolute;
		left: 9px;
		top: 55px;
		width: 6px;
		height: 90%;
		background: rgba(247, 195, 114, 0.75);
		border-radius: 8px;
	}

	.thin-border {
		position: absolute;
		left: 22px;
		top: 55px;
		width: 2px;
		height: 90%;
		background: rgba(247, 195, 114, 0.75);
		border-radius: 8px;
	}

	.patch {
		width: 100%;
		height: 100%;
		background: rgba(0,0,0, 0.6);
		position: fixed;
		z-index: 1;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
	}

	.menu-items ul li {
		list-style: none;
	}

	.menu-items ul li a {
		color: var(--gray-dark);
		display: block;
		padding: 8px 0;
		margin: 2px 0;
	}

	ul {
		padding: 0;
	}

	.close-btn {
		position: absolute;
		top: 0;
		right: 0;
		opacity: 1;
		color: var(--gray-dark);
		font-size: 20px;
	}

	.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
        opacity: 1;
    }

    .close-btn {
        opacity: 1;
    }

    .close-icon, .close-icon-active {
        width: 24px;
        height: 24px;
    }

    .close-icon-active {
        display: none;
    }
    
    .close-btn:hover .close-icon {
        display: none;
    }

    .close-btn:hover .close-icon-active {
        display: inline-block;
    }

    .box {
    	position: relative;
    	min-width: 160px;
    }


   /* ul li {
    	cursor: pointer;
    	color: var(--primary);
    	font-size: 14px;
    }*/

</style>